"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const createIconComponent_1 = require("../createIconComponent");
exports.default = createIconComponent_1.default("Star", React.createElement("path", { fill: "currentColor", d: "M12,0.9l2.5,7.6l0.3,0.8h0.9h8l-6.5,4.7l-0.7,0.5l0.3,0.8l2.5,7.6l-6.5-4.7L12,17.9l-0.7,0.5l-6.5,4.7l2.5-7.6l0.3-0.8\n\tl-0.7-0.5L0.3,9.4h8h0.9l0.3-0.8L12,0.9z" }));
//# sourceMappingURL=Star.js.map